import { useTheme } from '@mui/material/styles';
import type { Theme } from '@mui/material/styles';

// Figma-specific palette, separate from the admin's existing brand colors.
export const claimsToolPalette = {
  primary: '#07378F',
  heading: '#2D3E91',
  surface: '#FFFFFF',
  surfaceMuted: '#FAFAFA',
  surfaceSubtle: '#F1F2F5',
  tableHeader: '#FBFCFE',
  text: '#251F1F',
  textSecondary: '#7B7B86',
  textMuted: '#6E7080',
  textLabel: '#8A8C99',
  textSubdued: '#4A4C59',
  inputText: '#616161',
  icon: '#B6BAC8',
  linkIcon: '#7B8DB8',
  ai: '#B471DE',
  border: '#E6E7EC',
  borderSubtle: '#EFEFF1',
  borderInput: '#D6D8E0',
  borderLight: '#EDEDED',
  borderBrand: '#C6D4F3',
  selected: '#E7EDF9',
  hover: '#F4F7FD',
  neutral: '#EFEFF1',
  count: '#F2F3F6',
  emphasis: '#F3F6FB',
  documentList: {
    selected: '#EEF3FB',
    hover: '#F8F9FD',
    border: '#F5F5F7',
    icon: '#6B7280',
    iconBackground: '#F3F4F6',
    fileBackground: '#F7F8FC',
    fileBorder: '#EBEBEE',
    fileHover: '#EFF3FB',
    fileSelected: '#E4ECF8',
    fileIcon: '#9CA3AF',
  },
  status: {
    firstReview: '#F3E2F9',
    secondReview: '#FCF1D5',
    escalated: '#FFDEDC',
    escalatedText: '#A82D24',
    required: '#FCF1D5',
    requiredText: '#8A6D1F',
    assessed: '#DFFCEB',
    assessedText: '#2B5F2A',
  },
  confidence: {
    high: '#66BA47',
    medium: '#E97E19',
    low: '#E5435E',
  },
};

declare module '@mui/material/styles' {
  interface Palette {
    claimsTool?: typeof claimsToolPalette;
  }

  interface PaletteOptions {
    claimsTool?: typeof claimsToolPalette;
  }
}

export const getClaimsToolPalette = (theme: Theme) =>
  theme.palette.claimsTool ?? claimsToolPalette;

export const useClaimsToolPalette = () => getClaimsToolPalette(useTheme());
